// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.senddata-page {
    min-height: calc(100vh - 68px);
    padding: 2rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: var(--bg-primary);
}

.senddata-container {
    max-width: 720px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.senddata-title {
    color: var(--text-primary);
    font-size: 1.75rem;
    font-weight: 700;
    margin: 0;
    text-align: center;
}

.card-block {
    background: var(--bg-card);
    border-radius: var(--radius);
    padding: 1.5rem 2rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
}

.senddata-subtitle {
    color: var(--text-primary);
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 1rem 0;
}

.senddata-desc {
    color: var(--text-secondary);
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0 0 0.5rem 0;
}

.senddata-desc.muted {
    color: var(--text-muted);
    margin-bottom: 1rem;
}

.senddata-note {
    margin-top: 0.75rem;
    padding: 0.75rem;
    background: var(--bg-secondary);
    border-radius: var(--radius-sm);
    border-left: 3px solid var(--accent);
}

.senddata-type-tabs {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.senddata-tab {
    padding: 0.75rem 1.25rem;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border-color);
    background: var(--bg-secondary);
    color: var(--text-secondary);
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: var(--font);
}

.senddata-tab:hover {
    border-color: var(--accent);
    color: var(--text-primary);
    background: var(--bg-card-hover);
}

.senddata-tab.active {
    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
    border-color: var(--accent);
    color: white;
}

.form-row {
    margin-bottom: 1rem;
}

.form-row:last-child {
    margin-bottom: 0;
}

.form-row-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
}

.form-label {
    display: block;
    color: var(--text-secondary);
    font-size: 0.9rem;
    margin-bottom: 0.35rem;
}

.form-label .required {
    color: var(--error);
}

.form-input {
    width: 100%;
    padding: 0.75rem 1rem;
    background: var(--input-bg);
    border: 1px solid var(--input-border);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    font-size: 1rem;
    font-family: var(--font);
    transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-glow);
}

.form-input.error {
    border-color: var(--error);
}

.form-input.small {
    max-width: 180px;
}

.form-textarea {
    resize: vertical;
    min-height: 80px;
}

.form-select {
    padding: 0.75rem 1rem;
    background: var(--input-bg);
    border: 1px solid var(--input-border);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    font-size: 1rem;
    font-family: var(--font);
    min-width: 140px;
    cursor: pointer;
}

.form-select:focus {
    outline: none;
    border-color: var(--accent);
}

.form-error {
    display: block;
    color: var(--error);
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.payment-orders-block {
    margin: 1rem 0;
}

.payment-orders-block .form-error {
    display: block;
    margin-bottom: 0.5rem;
}

.payment-order-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
}

.payment-order-row .form-input.small {
    flex: 0 0 140px;
}

.add-row-btn {
    padding: 0.4rem 0.75rem;
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
    color: var(--accent-light);
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s;
}

.add-row-btn:hover {
    background: var(--bg-card-hover);
    border-color: var(--accent);
}

.remove-row-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background: var(--error-bg);
    color: var(--error);
    border-radius: var(--radius-sm);
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s;
}

.remove-row-btn:hover:not(:disabled) {
    background: var(--error);
    color: white;
}

.remove-row-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.file-upload-zone {
    display: block;
    cursor: pointer;
    margin-bottom: 0.5rem;
}

.file-upload-input {
    display: none;
}

.file-upload-placeholder {
    border: 2px dashed var(--border-color);
    border-radius: var(--radius);
    padding: 2rem;
    text-align: center;
    color: var(--text-secondary);
    font-size: 0.95rem;
    transition: all 0.2s;
    background: var(--bg-secondary);
}

.file-upload-zone:hover .file-upload-placeholder {
    border-color: var(--accent);
    color: var(--text-primary);
    background: var(--bg-card-hover);
}

.file-upload-icon {
    display: block;
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

.file-list {
    list-style: none;
    margin: 1rem 0 0 0;
    padding: 0;
}

.file-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    background: var(--bg-secondary);
    border-radius: var(--radius-sm);
    margin-bottom: 0.35rem;
}

.file-list-name {
    color: var(--text-primary);
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-list-remove {
    padding: 0.25rem 0.5rem;
    background: transparent;
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
    color: var(--text-secondary);
    font-size: 0.85rem;
    cursor: pointer;
    flex-shrink: 0;
    margin-left: 0.5rem;
}

.file-list-remove:hover {
    border-color: var(--error);
    color: var(--error);
}

.senddata-actions {
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
}

.senddata-submit-btn {
    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
    color: white;
    border: none;
    padding: 1rem 2.5rem;
    border-radius: var(--radius-sm);
    font-size: 1.05rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: var(--shadow-accent);
    font-family: var(--font);
    min-width: 200px;
}

.senddata-submit-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, var(--accent-hover) 0%, #1d4ed8 100%);
    box-shadow: 0 6px 20px var(--accent-glow);
    transform: translateY(-2px);
}

.senddata-submit-btn:active:not(:disabled) {
    transform: translateY(0);
}

.senddata-submit-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .senddata-page {
        padding: 1rem;
    }

    .card-block {
        padding: 1.25rem;
    }

    .senddata-type-tabs {
        flex-direction: column;
    }

    .senddata-tab {
        width: 100%;
        text-align: center;
    }

    .payment-order-row {
        flex-wrap: wrap;
    }

    .payment-order-row .form-input.small {
        flex: 1 1 100%;
        max-width: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/SendData.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,oBAAoB;IACpB,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,+BAA+B;IAC/B,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,qCAAqC;IACrC,+BAA+B;IAC/B,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,+EAA+E;IAC/E,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;IACf,wBAAwB;IACxB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,+BAA+B;IAC/B,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,qCAAqC;IACrC,+BAA+B;IAC/B,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,+EAA+E;IAC/E,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yEAAyE;IACzE,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":[".senddata-page {\r\n    min-height: calc(100vh - 68px);\r\n    padding: 2rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    background: var(--bg-primary);\r\n}\r\n\r\n.senddata-container {\r\n    max-width: 720px;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem;\r\n}\r\n\r\n.senddata-title {\r\n    color: var(--text-primary);\r\n    font-size: 1.75rem;\r\n    font-weight: 700;\r\n    margin: 0;\r\n    text-align: center;\r\n}\r\n\r\n.card-block {\r\n    background: var(--bg-card);\r\n    border-radius: var(--radius);\r\n    padding: 1.5rem 2rem;\r\n    box-shadow: var(--shadow-card);\r\n    border: 1px solid var(--border-color);\r\n}\r\n\r\n.senddata-subtitle {\r\n    color: var(--text-primary);\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    margin: 0 0 1rem 0;\r\n}\r\n\r\n.senddata-desc {\r\n    color: var(--text-secondary);\r\n    font-size: 0.95rem;\r\n    line-height: 1.5;\r\n    margin: 0 0 0.5rem 0;\r\n}\r\n\r\n.senddata-desc.muted {\r\n    color: var(--text-muted);\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.senddata-note {\r\n    margin-top: 0.75rem;\r\n    padding: 0.75rem;\r\n    background: var(--bg-secondary);\r\n    border-radius: var(--radius-sm);\r\n    border-left: 3px solid var(--accent);\r\n}\r\n\r\n.senddata-type-tabs {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.senddata-tab {\r\n    padding: 0.75rem 1.25rem;\r\n    border-radius: var(--radius-sm);\r\n    border: 1px solid var(--border-color);\r\n    background: var(--bg-secondary);\r\n    color: var(--text-secondary);\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    font-family: var(--font);\r\n}\r\n\r\n.senddata-tab:hover {\r\n    border-color: var(--accent);\r\n    color: var(--text-primary);\r\n    background: var(--bg-card-hover);\r\n}\r\n\r\n.senddata-tab.active {\r\n    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\r\n    border-color: var(--accent);\r\n    color: white;\r\n}\r\n\r\n.form-row {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.form-row:last-child {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.form-row-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.form-label {\r\n    display: block;\r\n    color: var(--text-secondary);\r\n    font-size: 0.9rem;\r\n    margin-bottom: 0.35rem;\r\n}\r\n\r\n.form-label .required {\r\n    color: var(--error);\r\n}\r\n\r\n.form-input {\r\n    width: 100%;\r\n    padding: 0.75rem 1rem;\r\n    background: var(--input-bg);\r\n    border: 1px solid var(--input-border);\r\n    border-radius: var(--radius-sm);\r\n    color: var(--text-primary);\r\n    font-size: 1rem;\r\n    font-family: var(--font);\r\n    transition: border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.form-input:focus {\r\n    outline: none;\r\n    border-color: var(--accent);\r\n    box-shadow: 0 0 0 3px var(--accent-glow);\r\n}\r\n\r\n.form-input.error {\r\n    border-color: var(--error);\r\n}\r\n\r\n.form-input.small {\r\n    max-width: 180px;\r\n}\r\n\r\n.form-textarea {\r\n    resize: vertical;\r\n    min-height: 80px;\r\n}\r\n\r\n.form-select {\r\n    padding: 0.75rem 1rem;\r\n    background: var(--input-bg);\r\n    border: 1px solid var(--input-border);\r\n    border-radius: var(--radius-sm);\r\n    color: var(--text-primary);\r\n    font-size: 1rem;\r\n    font-family: var(--font);\r\n    min-width: 140px;\r\n    cursor: pointer;\r\n}\r\n\r\n.form-select:focus {\r\n    outline: none;\r\n    border-color: var(--accent);\r\n}\r\n\r\n.form-error {\r\n    display: block;\r\n    color: var(--error);\r\n    font-size: 0.85rem;\r\n    margin-top: 0.25rem;\r\n}\r\n\r\n.payment-orders-block {\r\n    margin: 1rem 0;\r\n}\r\n\r\n.payment-orders-block .form-error {\r\n    display: block;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.payment-order-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.payment-order-row .form-input.small {\r\n    flex: 0 0 140px;\r\n}\r\n\r\n.add-row-btn {\r\n    padding: 0.4rem 0.75rem;\r\n    background: var(--bg-secondary);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: var(--radius-sm);\r\n    color: var(--accent-light);\r\n    font-size: 0.9rem;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.add-row-btn:hover {\r\n    background: var(--bg-card-hover);\r\n    border-color: var(--accent);\r\n}\r\n\r\n.remove-row-btn {\r\n    width: 32px;\r\n    height: 32px;\r\n    padding: 0;\r\n    border: none;\r\n    background: var(--error-bg);\r\n    color: var(--error);\r\n    border-radius: var(--radius-sm);\r\n    font-size: 1.25rem;\r\n    line-height: 1;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.remove-row-btn:hover:not(:disabled) {\r\n    background: var(--error);\r\n    color: white;\r\n}\r\n\r\n.remove-row-btn:disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.file-upload-zone {\r\n    display: block;\r\n    cursor: pointer;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.file-upload-input {\r\n    display: none;\r\n}\r\n\r\n.file-upload-placeholder {\r\n    border: 2px dashed var(--border-color);\r\n    border-radius: var(--radius);\r\n    padding: 2rem;\r\n    text-align: center;\r\n    color: var(--text-secondary);\r\n    font-size: 0.95rem;\r\n    transition: all 0.2s;\r\n    background: var(--bg-secondary);\r\n}\r\n\r\n.file-upload-zone:hover .file-upload-placeholder {\r\n    border-color: var(--accent);\r\n    color: var(--text-primary);\r\n    background: var(--bg-card-hover);\r\n}\r\n\r\n.file-upload-icon {\r\n    display: block;\r\n    font-size: 2rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.file-list {\r\n    list-style: none;\r\n    margin: 1rem 0 0 0;\r\n    padding: 0;\r\n}\r\n\r\n.file-list-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0.5rem 0.75rem;\r\n    background: var(--bg-secondary);\r\n    border-radius: var(--radius-sm);\r\n    margin-bottom: 0.35rem;\r\n}\r\n\r\n.file-list-name {\r\n    color: var(--text-primary);\r\n    font-size: 0.9rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.file-list-remove {\r\n    padding: 0.25rem 0.5rem;\r\n    background: transparent;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: var(--radius-sm);\r\n    color: var(--text-secondary);\r\n    font-size: 0.85rem;\r\n    cursor: pointer;\r\n    flex-shrink: 0;\r\n    margin-left: 0.5rem;\r\n}\r\n\r\n.file-list-remove:hover {\r\n    border-color: var(--error);\r\n    color: var(--error);\r\n}\r\n\r\n.senddata-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.senddata-submit-btn {\r\n    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\r\n    color: white;\r\n    border: none;\r\n    padding: 1rem 2.5rem;\r\n    border-radius: var(--radius-sm);\r\n    font-size: 1.05rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    box-shadow: var(--shadow-accent);\r\n    font-family: var(--font);\r\n    min-width: 200px;\r\n}\r\n\r\n.senddata-submit-btn:hover:not(:disabled) {\r\n    background: linear-gradient(135deg, var(--accent-hover) 0%, #1d4ed8 100%);\r\n    box-shadow: 0 6px 20px var(--accent-glow);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.senddata-submit-btn:active:not(:disabled) {\r\n    transform: translateY(0);\r\n}\r\n\r\n.senddata-submit-btn:disabled {\r\n    opacity: 0.7;\r\n    cursor: not-allowed;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .senddata-page {\r\n        padding: 1rem;\r\n    }\r\n\r\n    .card-block {\r\n        padding: 1.25rem;\r\n    }\r\n\r\n    .senddata-type-tabs {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .senddata-tab {\r\n        width: 100%;\r\n        text-align: center;\r\n    }\r\n\r\n    .payment-order-row {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .payment-order-row .form-input.small {\r\n        flex: 1 1 100%;\r\n        max-width: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
